<div class="photoPackage">
  @if (!!package.icon?.length) {
    <img
         [src]="
          (package.icon)
          | publicImageUrl: 400:400
          | async"
      />
  }
</div>
<div class="information">
  <ng-scrollbar>
    <ng-container *ngTemplateOutlet="information"></ng-container>
  </ng-scrollbar>
  <div class="buttons">
    <ng-container *libIsHandset="desktop">
      <div>
        <h3></h3>
        @if (!freePackage) {
          <h3 class="cost"><span translate>clhop0e2o000008mfhq6j87do</span> {{package.price | pricePicker}}</h3>
        }
        @if (freePackage) {
          <h3 class="cost" translate>clhop0lu9000108mfgwmdffn6</h3>
        }
      </div>
      <div>
        <lib-button (click)="hideDialog.emit()" forceContext="common" translate>comeBack</lib-button>
        <lib-button (click)="addPacketToBasket.emit()" translate>choose</lib-button>
      </div>
    </ng-container>
    <ng-template #desktop>
      <div>
        <h2></h2>
        @if (!freePackage) {
          <h2 class="cost"><span translate>clhop0e2o000008mfhq6j87do</span> {{package.price | pricePicker}}</h2>
        }
        @if (freePackage) {
          <h2 class="cost" translate>clhop0lu9000108mfgwmdffn6</h2>
        }
      </div>
      <div>
        <div></div>
        <lib-button (click)="addPacketToBasket.emit()" lg translate>choose</lib-button>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #information>
  <div class="productsList">
    <table>
      <h1>{{package.name}}</h1>

      @if ((oneImageInShop$ | async).length) {
        <h2 translate>clhopp85s000108jleivkbx53</h2>
      }
      @for (printAndFile of oneImageInShop$ | async; track printAndFile) {
        <div>
          @if (printAndFile.file.length) {
            <h3 translate>clhkibet0000008jl7g3d3bei</h3>
          }
          @for (file of printAndFile.file; track file) {
            <div class="printAndFile">
              @if (file.count && file.count > 0) {
                <p>
                  <span class="count">{{file.count}}x</span>
                  @if (file.isFull) {
                    <span>{{file.isFull | fileName | async | langPicker | async}} <span translate>clhopwuik000008mmbtf7054x</span></span>
                  }
                  @if (!file.isFull) {
                    <span><span translate>file</span> {{ file.size }}px <span translate>clhopwuik000008mmbtf7054x</span></span>
                  }
                  @for (group of printAndFile.groups; track group) {
                    <span>
                      @if ((group | namePhotoGroup | async)?.length) {
                        <span class="group">{{group | namePhotoGroup | async | langPicker | async}}</span>&nbsp;
                      }
                    </span>
                  }
                </p>
              }
            </div>
          }
        </div>
      }
      @for (printAndFile of oneImageInShop$ | async; track printAndFile) {
        <div>
          @if (printAndFile.print.length) {
            <h3 class="subtitle" translate>clhkk55p8000008l79rn499cq</h3>
          }
          @for (print of printAndFile.print; track print) {
            <div class="printAndFile">
              @if (print.count && print.count > 0) {
                <p>
                  <span class="count">{{print.count}}x</span>
                  <span><span translate>clhopy40j000008ibc2bchy1c</span>
                  {{ print.printFormatId | printFormatLabel | async }} {{ print.printPaperId | printPaperLabel | async }}
                  <span translate>clhopwuik000008mmbtf7054x</span></span>
                  @for (group of printAndFile.groups; track group) {
                    <span>
                      @if ((group | namePhotoGroup | async)?.length) {
                        <span class="group">{{group | namePhotoGroup | async | langPicker | async}}</span>&nbsp;
                      }
                    </span>
                  }
                </p>
              }
              @if (print.count && print.count > 0) {
                <div class="button">
                  <lib-button icon-only
                    (click)="showPrintDetails(print.printFormatId, print.printPaperId)">
                    <mat-icon>info_outlined</mat-icon>
                  </lib-button>
                </div>
              }
            </div>
          }
        </div>
      }


      @if ((anyImageInShop$ | async).length) {
        <h2 translate>clhor51fs000008jp8t8g1y3f</h2>
      }
      @for (printAndFile of anyImageInShop$ | async; track printAndFile) {
        <div>
          @if (printAndFile.file.length) {
            <h3 translate>clhkibet0000008jl7g3d3bei</h3>
          }
          @for (file of printAndFile.file; track file) {
            <div class="printAndFile">
              @if (file.count && file.count > 0) {
                <p>
                  <span class="count">{{file.count}}x</span>
                  @if (file.isFull) {
                    <span>{{file.isFull | fileName | async | langPicker | async}}
                      <span translate>clhopwuik000008mmbtf7054x</span></span>
                    }
                    @if (!file.isFull) {
                      <span><span translate>file</span> {{ file.size }}px <span translate>clhopwuik000008mmbtf7054x</span></span>
                    }
                    @for (group of printAndFile.groups; track group) {
                      <span>
                        @if ((group | namePhotoGroup | async)?.length) {
                          <span class="group">{{group | namePhotoGroup | async | langPicker | async}}</span>&nbsp;
                        }
                      </span>
                    }
                  </p>
                }
              </div>
            }
          </div>
        }
        @for (printAndFile of anyImageInShop$ | async; track printAndFile) {
          <div>
            @if (printAndFile.print.length) {
              <h3 class="subtitle" translate>clhkk55p8000008l79rn499cq</h3>
            }
            @for (print of printAndFile.print; track print) {
              <div class="printAndFile">
                @if (print.count && print.count > 0) {
                  <p>
                    <lib-button icon-only
                      (click)="showPrintDetails(print.printFormatId, print.printPaperId)">
                      <mat-icon>info_outlined</mat-icon>
                    </lib-button>
                    <span class="count">{{print.count}}x</span>
                    <span><span translate>clhopy40j000008ibc2bchy1c</span>
                    {{ print.printFormatId | printFormatLabel | async }} {{ print.printPaperId | printPaperLabel | async }}
                    <span translate>clhopwuik000008mmbtf7054x</span></span>
                    @for (group of printAndFile.groups; track group) {
                      <span>
                        @if ((group | namePhotoGroup | async)?.length) {
                          <span class="group">{{group | namePhotoGroup | async | langPicker | async}}</span>&nbsp;
                        }
                      </span>
                    }
                  </p>
                }
              </div>
            }
            @if (printAndFile.addFileToPrintInPackage) {
              <p>{{true | fileName | async | langPicker | async}} <span translate>clhor5dj6000108jp731e8w8a</span></p>
            }
          </div>
        }


        @for (printAndFile of pickedImageInShop$ | async; track printAndFile) {
          <div>
            <div class="photo">@if ((pickedImageInShop$ | async).length) {
              <h2 translate>clhorg5h8000008mk6fyl6ncl</h2>
            }
            <span (click)="openFullPhoto(printAndFile.forcedImage.photoId)">
              <img
                  [src]="
            printAndFile.forcedImage.photoId
              | photoData
              | async
              | getImageUrl
                : $safeNavigationMigration((printAndFile.forcedImage.photoId | photoData | async)?.photoGroupId)
                : 'anyone'
                : context
                : (shoppingCartContext$ | async).contextId
                : 400
              | async
          "
                />
                <mat-icon class="magnifier">search</mat-icon>
              </span>
            </div>
            @if (printAndFile.file.length > 0) {
              <h3 translate>clhkibet0000008jl7g3d3bei</h3>
            }
            @for (file of printAndFile.file; track file) {
              <div class="printAndFile">
                @if (file.count && file.count > 0) {
                  <p>
                    <span class="count">{{file.count}}x</span>
                    @if (file.isFull) {
                      <span>{{file.isFull | fileName | async | langPicker | async}}</span>
                    }
                    @if (!file.isFull) {
                      <span><span translate>file</span> {{ file.size }}px</span>
                    }
                  </p>
                }
              </div>
            }
            @if (printAndFile.print.length > 0) {
              <h3 translate>clhkk55p8000008l79rn499cq</h3>
            }
            @for (print of printAndFile.print; track print) {
              <div class="printAndFile">
                @if (print.count && print.count > 0) {
                  <p>
                    <span class="count">{{print.count}}x</span>
                    <span><span translate>clhopy40j000008ibc2bchy1c</span> {{ print.printFormatId | printFormatLabel | async }}
                  {{ print.printPaperId | printPaperLabel | async }}</span>
                </p>
              }
              @if (print.count && print.count > 0) {
                <div class="button">
                  <lib-button icon-only
                    (click)="showPrintDetails(print.printFormatId, print.printPaperId)">
                    <mat-icon>info_outlined</mat-icon>
                  </lib-button>
                </div>
              }
            </div>
          }
        </div>
      }


      @if (package.productConfig.length > 0) {
        <h3 translate>clhn4sj7c000008jpcuiccu4h</h3>
      }
      @for (product of package.productConfig; track product; let i = $index) {
        <span>
          <span class="whiteSpace">
            <tr><div class="count">{{product.qty}}x</div></tr>
            @if (((product.customName | langPicker) | async)?.length) {
              <span
                >
              {{product.customName | langPicker | async}} </span>
            }
            @if (!((product.customName | langPicker) | async)?.length) {
              <span
                >
              {{(product.productId | productInShop | async).name}} </span>
            }
            <span>
              <button mat-icon-button (click)="openInformationOnProduct(product.productInPackageId, product.productId)">
                <mat-icon>info_outlined</mat-icon>
              </button>
            </span>
          </span>@if (package.productConfig.length -1 > i) {
          <span>,</span>
        }
      </span>
    }

  </table>
</div>
</ng-template>
